//------------------//
// Swiper.js Slider Module
// https://swiperjs.com
//------------------//
import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay, Mousewheel } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';

// Initialize Swiper sliders
const image_sliders = document.querySelectorAll('[data-image-gallery]');
const event_sliders = document.querySelectorAll('[data-event-slider]');

image_sliders.forEach((item) => {
    item.querySelectorAll('.swiper').forEach((slider) => {
        new Swiper(slider, {
            slidesPerView: 'auto',
            loop: true,
            grabCursor: true,
            spaceBetween: 5,
            autoplay: {
                delay: 5000,
            },
            centeredSlides: true,
            navigation: {
                nextEl: item.querySelector('.swiper-button-next'),
                prevEl: item.querySelector('.swiper-button-prev')
            },
            mousewheel: {
                forceToAxis: true,
            },
            modules: [Navigation, Autoplay, Mousewheel]
        });
    });
});

const exhibition_sliders = document.querySelectorAll('[data-exhibition-slider]');
exhibition_sliders.forEach((item) => {
    if (item.querySelectorAll('.swiper-slide').length <= 1) return;
    new Swiper(item.querySelector('.swiper'), {
        slidesPerView: 1,
        loop: true,
        autoHeight: true,
        speed: 1000,
        spaceBetween: 10,
        grabCursor: true,
        navigation: {
            nextEl: item.querySelector('.swiper-button-next'),
            prevEl: item.querySelector('.swiper-button-prev'),
        },
        pagination: {
            el: item.querySelector('.exhibition-pagination'),
            clickable: true,
        },
        modules: [Navigation, Pagination],
    });
});

event_sliders.forEach((item) => {
    let breakpoints = {
        1024: {
            slidesPerView: 4.25,
        },
        550: {
            slidesPerView: 2.25,
        },
    }

    new Swiper(item.querySelector('.swiper'), {
        slidesPerView: '1.5',
        grabCursor: true,
        spaceBetween: 10,
        watchSlidesProgress: true,
        breakpoints: breakpoints,
        navigation: {
            nextEl: item.querySelector('.swiper-button-next'),
            prevEl: item.querySelector('.swiper-button-prev')
        },
        mousewheel: {
            forceToAxis: true,
        },
        modules: [Navigation, Mousewheel]
    });
});